import { CBadge, CCol, CContainer, CForm, CRow } from "@coreui/react";
import { Typography } from "@mui/material";
import React from "react";
import "./Quiz.css";

function YesNoSuperadmin({
  type,
  num,
  question,
  score,
  data,
  onAnswerChange,
  questionID,
  questionTypeID,
}) {
  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
  };

  const getStyle = (ans) => {
    if (ans.value === 1) {
      return {
        backgroundColor: "#28a745", // Green background
        color: "white", // White text
      };
    }
    return {};
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
              <Typography
                variant="question"
                component="div"
                gutterBottom
                sx={{ color: "primary.main", mb: 2 }}
              >
                {`Q${num + 1}. ${question}`}
              </Typography>
              <CForm>
                <ul>
                  <CRow xs={{ gutterY: 2 }}>
                    <CCol xs={6}>
                      <CRow>
                        {data.map((ans) => (
                          <CCol xs={6} lg={5} key={ans.answerId}>
                            <div className="d-flex">
                              <input
                                disabled={type === "3" ? false : true}
                                className="form-check-input options"
                                type="radio"
                                name={`question-${questionID}`}
                                id={ans.answerId}
                                value={ans.value}
                                onChange={() =>
                                  handleSelectAnswer(ans.answerId)
                                }
                                style={getStyle(ans)}
                              />
                              <label
                                className="optionText"
                                style={{ marginLeft: "4px" }}
                                htmlFor={ans.answerId}
                              >
                                {ans.label}
                              </label>
                            </div>
                          </CCol>
                        ))}
                      </CRow>
                    </CCol>
                  </CRow>
                </ul>
              </CForm>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default YesNoSuperadmin;
